var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"inline-block px-8 py-3 mb-3 rounded-full border-2 border-solid tracking-wider font-semibold text-sm mr-2",class:[
  'text-'+_vm.textColor,
  'border-'+_vm.borderColor,
  'bg-'+_vm.backgroundColor,
  'hover:text-'+_vm.textColorHover,
  'hover:border-'+_vm.borderColorHover,
  'hover:bg-'+_vm.backgroundColorHover ],attrs:{"href":"#"}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }